import { commandDefinition, optionsDefinition } from "../../Commons/Options/CommandBasedOptionsParser";
import { CommonOptions } from "../CommonOptions/CommonOptions";
import { devModeOption, logVerbosityOption } from "../CommonOptions/CommonOptionDefintions";

export interface DevelopmentBuildOptions extends CommonOptions {
    watch: boolean;
    formGlobs: string[];
    skipGeneration: boolean;
    skipBuildEngine: boolean;
    skipWebPackCompilation: boolean;
    buildDebugOnly: boolean;
    continueOnError: boolean;
    buildCandyWidget: boolean;
}

export const devBuildCommandDefinition = commandDefinition<"dev-build", DevelopmentBuildOptions>(
    "dev-build",
    "dev-build",
    optionsDefinition(
        {
            alias: "w",
            name: "watch",
            defaultValue: { watch: false },
            parse: input => ({ watch: input }),
            doesNotRequireValue: true,
            description:
                "Watch-режим. Выполняет сборку форм, а затем пересобирает при изменениях. В том числе движка, генератора и статических ресурсов.",
        },
        {
            alias: "g",
            name: "gfvs",
            defaultValue: { formGlobs: [] },
            parse: (input: string[]) => ({ formGlobs: input }),
            defaultOption: true,
            multiple: true,
            description: "Одна или несколько GFV или GFV-масок для пересобрки.",
        },
        {
            alias: "n",
            name: "skip-generation",
            defaultValue: { skipGeneration: false },
            parse: (input: boolean) => ({ skipGeneration: input }),
            doesNotRequireValue: true,
            description:
                "Не выполнять генарцию формы из сахара, будет выполняться только компиляция исходников формы из каталога форм.",
        },
        {
            name: "skip-webpack",
            defaultValue: { skipWebPackCompilation: false },
            parse: (input: boolean) => ({ skipWebPackCompilation: input }),
            doesNotRequireValue: true,
            description: "Не запускать компиляцию сгенерированного кода. Для отладки результатов генерации.",
        },
        {
            name: "skip-engine",
            defaultValue: { skipBuildEngine: false },
            parse: (input: boolean) => ({ skipBuildEngine: input }),
            doesNotRequireValue: true,
            description: "Не запускать сборку runtime-движка. Для отладки результатов генерации.",
        },
        {
            name: "continue-on-error",
            doesNotRequireValue: true,
            defaultValue: { continueOnError: false },
            parse: (input: boolean) => ({ continueOnError: input }),
            description: "Не генерирует код ошибки в случае ошибки при генерации или компиляции формы.",
        },
        {
            alias: "d",
            name: "debug-only",
            defaultValue: { buildDebugOnly: false },
            parse: (input: boolean) => ({ buildDebugOnly: input }),
            doesNotRequireValue: true,
            description:
                "Собирать только debug-сборки движка и форм. " +
                "ВНИМАНИЕ: при работе в браузере необходимо использовать параметр ?debug=true",
        },
        {
            name: "build-candy-widget",
            doesNotRequireValue: true,
            defaultValue: { buildCandyWidget: false },
            parse: (input: boolean) => ({ buildCandyWidget: input }),
            description: "Собирать candy-виджет",
        },
        devModeOption,
        logVerbosityOption
    ),
    {
        description: "Выполняет сборку форм с ипользованием локальных исходников движка и генератора.",
        detailedDescription: `
Выполняет сборку форм с ипользованием локальных исходников движка и генератора.

### **ВАЖНО**
Эта команда собирает выполняет сборку форм в каталог ресурсов, но результаты сборки не являеются корректными для выкатывания в продакшен.
`.trim(),
        examples: `
### Написание и просмотр форм

В каталоге candy.farm запустить команды

\`\`\`
candy build 123456 -w
\`\`\`

\`\`\`
candy local-server
\`\`\`

* Переход на url http://localhost:9080/123456/form -- создаст черновик и откроет редактор
* Inner черновиков находится в каталоге candy.resources/.data

### Сборка формы для релиза

\`\`\`
candy build 123456
\`\`\`

### Переключение и сборка формы на использование последней стабильной

\`\`\`
candy build 123456 --use-last-stable-version
\`\`\`

Затем можно использовать пункт 'Написание и просмотр форм'

### Отладка форм с локальным движком

В каталоге candy.farm запустить команды

\`\`\`
candy dev-build 123456 -w
\`\`\`

\`\`\`
candy local-server
\`\`\`

* Переход на url http://localhost:9080/123456/form -- создаст черновик и откроет редактор
* Inner черновиков находится в каталоге candy.resources/.data

### Разработка и отладка движка

В этом случае удобно использовать сборку только отладочных скриптов.

\`\`\`
candy dev-build 123456 --watch --debug-only
\`\`\`

\`\`\`
candy local-server --redirect-to-debug-scripts
\`\`\`

* Переход на url http://localhost:9080/123456/form -- создаст черновик и откроет редактор
* Inner черновиков находится в каталоге candy.resources/.data
`.trim(),
    }
);
